import { NotificationModalComponent } from "widgets-module/components/notification/notification-modal.component";
import { NotificationOptionsModel } from "widgets-module/components/notification/notification-options.model";
import { NotificationPaneComponent } from "widgets-module/components/notification/notification-pane.component";

export class NotificationService {
    private _currentContext: JQuery | null = null;
    private _options: NotificationOptionsModel | null = null;

    private _panes: Array<NotificationPaneComponent> = [];
    private _modal: NotificationModalComponent | null = null;

    private bindEvents(): void {
        this._panes.forEach((pane) => {
            pane.on(NotificationPaneComponent.REMOVE_EVENT,)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
                .subscribe((x: NotificationPaneComponent) => {
                    this.markAsClosed(x.id);
                    x.destroy();
                });
        });

        if (this._modal) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            this._modal.on(NotificationModalComponent.REMOVE_EVENT).subscribe((x: NotificationModalComponent) => {
                this.markAsClosed(x.id);
                x.destroy();
            });
        }
    }

    private get closedNotificationIds(): Array<string> {
        const closedIdsValue = sessionStorage.getItem(this._options!.sessionKey) ?? "[]";
        return JSON.parse(closedIdsValue) as Array<string> || new Array<string>();
    }

    private markAsClosed(id: string): void {
        const closedIds = this.closedNotificationIds;
        closedIds.push(id);
        sessionStorage.setItem(this._options!.sessionKey, JSON.stringify(closedIds));
    }

    private parseContext(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const panes = $(NotificationPaneComponent.SELECTOR, this._currentContext);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        panes.each((index, entry) => {
            const paneContext = $(entry);
            const pane = new NotificationPaneComponent();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            pane.init(paneContext);
            this._panes.push(pane);
        });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const modalContext = $(NotificationModalComponent.SELECTOR, this._currentContext);
        if (modalContext?.length) {
            this._modal = new NotificationModalComponent();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-call
            this._modal.init(modalContext.first(), this._options.displayDelayInMilliseconds);
        }
    }

    private showNotifications(): void {
        const closedIds = this.closedNotificationIds;

        this._panes.forEach((x) => {
            if (!closedIds.includes(x.id)) {
                x.show();
            }
        });

        if (this._modal && !!this._modal.id && !closedIds.includes(this._modal.id)) {
            this._modal.show();
        }
    }

    public init(context: JQuery, options: NotificationOptionsModel): void {
        this._currentContext = context || this._currentContext;
        this._options = options || this._options;

        this.parseContext();
        this.showNotifications();
        this.bindEvents();
    }
}
